<p-select [ngModel]="activity" name="activity" [disabled]="mode !== DetailMode.EDITION"
          (ngModelChange)="activityChange.emit($event)" (onClear)="activityChange.emit(null)"
          [options]="activities" [optionLabel]="filterLabelField" optionValue="value"
          [filter]="true" [filterBy]="filterLabelField" appendTo="body"
          [showClear]="true" i18n-placeholder="@@common-none" placeholder="(none)"
          [required]="required" class="acted-highlight-req metadata-field" [tabindex]="tabindex">
</p-select>
